import { number } from "yup";
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const FollowConfigService = {

    getTags: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-tags-flow/${account_id}`)
    },

    changeStatus: (account_id: number, data: {
        id: number,
        status: number
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/change-status-tags-flow/${account_id}`, data);
    },

    addTag: (account_id: number, data: {
        name: string,
        trigger: string,
        form_id: number,
        sub_account_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/add-tags-flow/${account_id}`, data);
    },

    editTag: (account_id: number, data: {
        id: number,
        name: string,
        trigger: string,
        form_id: number,
        sub_account_id: number
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/edit-tags-flow/${account_id}`, data);
    },

    deleteTag: (account_id: number, id:number) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/delete-tags-flow/${account_id}`, {data:{id}});
    },
}